export default "__VITE_ASSET__DpTk6dtQ__"